/**
 * By default, JSON.stringify() removes properties with undefined values. Use this to replace these values with null.
 * Currently used in shared menus to intentionally send `null` for specific values.
 * @example JSON.stringify(obj, replaceUndefinedWithNull);
 */
export const undefinedWithNullReplacer = (_key: string, value: any) => (value === undefined ? null : value);
